import { Link } from "react-router-dom";

export const Logo = ({ size = "md" }) => {
  const circle = size === "lg" ? "w-12 h-12" : "w-9 h-9";
  const word = size === "lg" ? "text-3xl" : "text-xl";
  return (
    <Link to="/" data-testid="site-logo" className="flex items-center gap-2.5 group">
      <img
        src="/khabrik-logo.png"
        alt="Khabrik logo"
        className={`${circle} rounded-full transition-transform duration-300 group-hover:rotate-12`}
      />
      <span className={`${word} font-bold tracking-tight text-white font-[Outfit]`}>
        Khabrik
      </span>
    </Link>
  );
};
